import jzhxLogo from '../assets/金陵中学河西分校.png';
import ndfzLogo from '../assets/南京大学附属中学.png';
import nflsLogo from '../assets/南京外国语学校.png';
import nj13zLogo from '../assets/南京市第十三中学.png';
import nj29zLogo from '../assets/nj29z.png';
import njbqzxLogo from '../assets/南京市板桥中学.png';
import njyzLogo from '../assets/南京市第一中学.png';
import njzhzxLogo from '../assets/南京中华中学.png';
import nsfzLogo from '../assets/南京师范大学附属中学.png';
import { getThroughSchoolList } from '../services/home.js';
import { getBrowserRuntimeConfig, getSchoolURL } from '../config/runtime.js';
import { responseData } from '../types/domain.js';
import type { School } from '../types/domain.js';
import type { ModelSaga, TypedModel } from './dva-types.js';

export interface HomeState {
  schools: School[];
}

function getSchoolUrl(slug: string): string {
  const runtimeConfig = getBrowserRuntimeConfig();
  return getSchoolURL(runtimeConfig.baseProductURL, slug, runtimeConfig.schoolURLStyle);
}

const model: TypedModel<HomeState> = {
  namespace: 'home',
  state: {
    schools: [
      { name: '南京外国语学校', logo: nflsLogo, url: getSchoolUrl('nfls') },
      { name: '南京师范大学附属中学', logo: nsfzLogo, url: getSchoolUrl('nsfz') },
      { name: '南京市第一中学', logo: njyzLogo, url: getSchoolUrl('njyz') },
      { name: '南京大学附属中学', logo: ndfzLogo, url: getSchoolUrl('ndfz') },
      { name: '金陵中学河西分校', logo: jzhxLogo, url: getSchoolUrl('jzhx') },
      { name: '南京市第十三中学', logo: nj13zLogo, url: getSchoolUrl('nj13z') },
      { name: '南京市第二十九中学', logo: nj29zLogo, url: getSchoolUrl('nj29jt') },
      { name: '中华中学', logo: njzhzxLogo, url: getSchoolUrl('njzhzx') },
      { name: '南京市板桥中学', logo: njbqzxLogo, url: getSchoolUrl('njbqzx') },
    ],
  } satisfies HomeState,
  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(() => {
        dispatch({ type: 'getThroughSchoolList' });
      });
    },
  },
  effects: {
    *getThroughSchoolList(_, { put }): ModelSaga {
      const response = yield getThroughSchoolList();
      const data = responseData<School[]>(response);
      yield put({
        type: 'update',
        payload: { schools: data },
      });
    },
  },
  reducers: {
    update(state: HomeState, { payload }: { payload: Partial<HomeState> }): HomeState {
      return { ...state, ...payload };
    },
  },
};

export default model;
